import {useNavigate} from '@github-ui/use-navigate'
import {type RefObject, useCallback, useState} from 'react'

import {DuplicateSavedViewDialog} from '../components/dialogs/DuplicateSavedViewDialog'
import {useSavedViewEndpoints} from '../contexts/SavedViewEndpointsContext'
import type {SavedView} from '../types'

interface UseDuplicateSavedViewDialogOptions {
  owner: string
  repo: string
  returnFocusRef?: RefObject<HTMLElement | null>
}

export function useDuplicateSavedViewDialog({owner, repo, returnFocusRef}: UseDuplicateSavedViewDialogOptions) {
  const navigate = useNavigate()
  const {basePath} = useSavedViewEndpoints(owner, repo)
  const [pendingDuplicate, setPendingDuplicate] = useState<SavedView | null>(null)

  const openDuplicateDialog = useCallback((view: SavedView) => {
    setPendingDuplicate(view)
  }, [])

  const duplicateDialog = pendingDuplicate ? (
    <DuplicateSavedViewDialog
      view={pendingDuplicate}
      owner={owner}
      repo={repo}
      onClose={() => setPendingDuplicate(null)}
      onSuccess={newView => navigate(`${basePath}/${encodeURIComponent(newView.id)}`)}
      returnFocusRef={returnFocusRef}
    />
  ) : null

  return {openDuplicateDialog, duplicateDialog}
}
